import { useMutation } from '@tanstack/react-query';
import { exportSampleToExcel, SampleExportParams } from '../services/sampleUserTypeService';
import { downloadBlob } from '@/features/dashboard/api/dashboardExport.api';
import { toast } from '@/hooks/use-toast';
import { format } from 'date-fns';

export const useSampleExport = () => {
  const mutation = useMutation({
    mutationFn: async (params: SampleExportParams) => {
      const blob = await exportSampleToExcel(params);
      return { blob, params };
    },
    onSuccess: ({ blob, params }) => {
      const dateLabel = params.sampleDate
        ? format(new Date(params.sampleDate), 'yyyy-MM-dd')
        : 'export';
      const filename = `muestras ${dateLabel}.xlsx`;
      downloadBlob(blob, filename);
      toast({
        title: 'Descarga completada',
        description: 'El archivo Excel se ha descargado exitosamente.',
      });
    },
    onError: (error: Error & { response?: { data?: { message?: string } } }) => {
      toast({
        title: 'Error al exportar',
        description: error?.response?.data?.message || 'Ocurrió un error al generar el archivo Excel.',
        variant: 'destructive',
      });
    },
  });

  return {
    exportToExcel: mutation.mutate,
    isExporting: mutation.isPending,
  };
};
